
export default {
    data() {
        return {
            cards: [
                {
                    image: '/deposit.png',
                    text: 'deposit',
                    color: { r: 251, g: 232, b: 139 },
                    path: '/player/deposits',
                },
                {
                    image: '/withdraw.png',
                    text: 'withdrawal',
                    color: { r: 43, g: 184, b: 57 },
                    path: '/player/withdrawals',
                },
            ],
        }
    },
}
